import { render, staticRenderFns } from "./OrgDetailsAddressEdit.vue?vue&type=template&id=791dfb62&scoped=true&"
import script from "./OrgDetailsAddressEdit.vue?vue&type=script&lang=js&"
export * from "./OrgDetailsAddressEdit.vue?vue&type=script&lang=js&"
import style0 from "./OrgDetailsAddressEdit.vue?vue&type=style&index=0&id=791dfb62&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791dfb62",
  null
  
)

export default component.exports